import React from "react";
import { withRouter } from "react-router";
import { AlertService } from "../../services/alert.service";
import { AuthenticationService } from "../../services/auth.service";
import { LOGIN_ROUTE, SIGNUP_CANDIDATURE_ROUTE } from "../../providers/routes";
import { t } from "../../translations/translation.service";
import "./index.css";

class SignupExpiredToken extends React.Component<any> {
  state = {
    processing: false,
  };
  
  handleClick = async (): Promise<void> => {
    if (this.state.processing) {
      return;
    }

    this.setState({ processing: true });

    const { username: email, token, opportunityId } = this.props.match.params;
    let refreshedToken = "";

    try {
      const refresh = await AuthenticationService.refreshToken(token, email);
      const newToken =
        refresh?.data?.token ||
        refresh?.data?.data?.token ||
        refresh?.data?.refreshToken;
      const hasRefreshError = !!refresh?.data?.errorMessage;

      if (refresh.status === 200 && !hasRefreshError && newToken) {
        refreshedToken = newToken;
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
    }

    if (!refreshedToken) {
      this.setState({ processing: false });
      AlertService.error(t("Não foi possível gerar um novo token. Tente novamente."));
      return;
    }

    const redirectTo = `${SIGNUP_CANDIDATURE_ROUTE
      .replace(":username", encodeURIComponent(email))
      .replace(":token", encodeURIComponent(refreshedToken))
      .replace(":opportunityId", encodeURIComponent(opportunityId))}?fromLogin=true`;

    const searchParams = new URLSearchParams();
    searchParams.set("email", email);
    searchParams.set("redirectTo", redirectTo);
    searchParams.set("expiredRoute", this.props.location.pathname);

    AuthenticationService.clearSession();

    this.props.history.push({
      pathname: LOGIN_ROUTE,
      search: `?${searchParams.toString()}`,
      state: {
        email,
        redirectTo,
        expiredRoute: this.props.location.pathname,
      },
    });
  }

  render() {
    return (
      <div className="main-header">
        <h1>OOPS!!</h1>
        <div className="text-center main-container">
          <section className="section-left">
            <img src={require("../../images/enter-processing-panel.png")} alt="imagem-esquerda" className="imagem-esquerda" width={"100%"}/>
          </section>
          <section className="section-right">
            <div className="content-right">
              <div className="header-right">
                <img src={require("../../images/enter-loading.png")} alt="Logo" className="logo" />
                <h1>{t("Token Expirado")}</h1>
              </div>
              <p>{t("Seu token de validação expirou.")}</p>
              <button className="button-refresh-token" disabled={this.state.processing} onClick={() => this.handleClick()}>{t("Clique aqui para seguir com o cadastro")}</button>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
export default withRouter(SignupExpiredToken);